require('./sendN1PasswordView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @core
const { formatText } = require('core/i18n').i18n;

// @actions
const sendN1PasswordActions = require('actions/sendN1Password');
const profile = require('actions/profile');

// @utils
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const StringHelper = require('utilities/stringHelper');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');

// @components
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const SendN1PasswordStep1 = require('components/contactCenter/sendN1Password/sendN1PasswordStep1/sendN1PasswordStep1');
const SendN1PasswordSuccessStep = require('components/contactCenter/sendN1Password/sendN1PasswordSuccessStep/sendN1PasswordSuccessStep');
const SendN1PasswordErrorStep = require('components/contactCenter/sendN1Password/sendN1PasswordErrorStep/sendN1PasswordErrorStep');


class SendN1PasswordViewContainer extends React.Component {
    componentDidMount() {
        const { requestProfile, history } = this.props;
        requestProfile(history);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
    }

    handleEndInteraction() {
        const url = '/disasterRecovery/customerFinder';
        this.props.history.push(url);
    }

    buildEndInteractionBlock() {
        const textEndInteraction = formatText('addImposition-disasterRecoveryConfirmationBackbtn');
        return (
            <div className="customer-finder__end-interaction-block">
                <div className="customer-finder__end-interaction-button-container">
                    <div className="customer-finder__end-interaction-button">
                        <OKButton modifier="link-complementary" size="small" onClick={this.handleEndInteraction}>
                            <span className="customer-finder__end-interaction-link">{textEndInteraction}</span>
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildContent() {
        const { immProfileFields } = this.props;
        const address = PersonalDataHelper.getFormattedAddress(immProfileFields);
        const username = StringHelper.toCamelCase(`${immProfileFields.get('nombreCliente')} ${immProfileFields.get('apellidoUno').get('apellido')}`);
        const onHandlerSendCode = this.props.postChange;
        return (
            <div>
                <SendN1PasswordStep1
                    address={address}
                    onConfirm={onHandlerSendCode}
                    username={username}
                    immProfileFields={immProfileFields} />
                {isDisasterRecoveryMode() && this.buildEndInteractionBlock()}
            </div>
        );
    }

    buildSuccessful() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <SendN1PasswordSuccessStep />
                </div>
            </div>
        );
    }

    buildFailureView() {
        return (
            <div className="row no-gutter">
                <div className="col-xs col-xs-12">
                    <SendN1PasswordErrorStep />
                </div>
            </div>
        );
    }

    buildDisasterRecoveryContent(titleHeader, mappingBreadcrumb, content) {
        return (

            <div className="sendn1-cc-view sendn1-cc-view--disaster-recovery">
                <OKCover size="small" section="pg" extraClass="sendn1-cc-view__cover">
                    <OKHeaderLanding title="" />
                </OKCover>
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true} />
                <div className="sendn1-cc-view__body">
                    {content}
                </div>
            </div>

        );
    }

    render() {
        const { immProfileFields, immSendN1Data } = this.props;
        const titleHeader = formatText('profileKeysLanding-title');
        const submitSuccessful = immSendN1Data.get('submitSuccessful');
        const errorReceived = immSendN1Data.get('errorReceived');
        const mappingBreadcrumb = [
            ...(!__CONTACT_CENTER__ ? [
                {
                    text: titleHeader,
                    url: '/myprofile/keys'
                }
            ] : []),
            {
                text: formatText('profileKeysLanding-requestNewKeyPost')
            }
        ]

        let content;
        if (submitSuccessful) {
            content = this.buildSuccessful();
        } else {
            if (!!errorReceived) {
                content = this.buildFailureView();
            }
            else {
                content = immProfileFields.get('isFetching') ? (<LoadingSection />) : this.buildContent();
            }
        }
        const disasterRecoveryContent = this.buildDisasterRecoveryContent(titleHeader, mappingBreadcrumb, content);

        return (
            isDisasterRecoveryMode() ? disasterRecoveryContent :
            <section>
                <OKHeaderCC
                    title={titleHeader}
                    breadcrumbConfig={mappingBreadcrumb}
                    showBreadBrumb={true} />
                <div>
                    {content}
                </div>
            </section>
        );
    }
}

SendN1PasswordViewContainer.propTypes = {
    immProfileFields: PropTypes.object.isRequired,
    immSendN1Data: PropTypes.object.isRequired,
    requestProfile: PropTypes.func,
    postChange: PropTypes.func,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = SendN1PasswordViewContainer;
module.exports.SendN1PasswordViewContainer = withRouter(connect(
    state => ({
        immProfileFields: state.profile,
        immSendN1Data: state.sendN1Password
    }), {
    requestProfile: profile.requestProfile,
    postChange: sendN1PasswordActions.postChange
})(SendN1PasswordViewContainer));
